// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__4hwNN","title":"Images90_title__oAGu4","images":"Images90_images__2QIq7"};